// @flow
import {getPlacePredictionsApi, getPlaceIdApi} from '../../api';
import {MapAutocompleteServices} from '../MapServices';

import type {SuggestedAddress, LatLng} from '../MapServices';
import type {AddressGeo as Location} from '../../../../entities';

type HerePlaceSuggested = {
  address: {
    countryCode: string,
    countryName: string,
    county: string,
    countyCode: string,
    label: string,
    state: string,
    stateCode: string,
  },
  id: string,
  mapView?: {
    east: number,
    north: number,
    south: number,
    west: number,
  },
  position: LatLng,
  resultType: string,
  scoring: {
    fieldScore: {[key: string]: any},
    queryScore: 1,
  },
  title?: string,
};
export class HereAutocompleteServices implements MapAutocompleteServices {
  getPlaceSuggestions = (input: string, country?: string): Promise<any> => {
    return getPlacePredictionsApi({
      provider: 'HERE',
      address: input,
      country: country || 'PER',
    }).toPromise();
  };

  getPlaceId = (placeId: string): Promise<any> => {
    return getPlaceIdApi({
      provider: 'HERE',
      place_id: placeId,
    }).toPromise();
  };

  formatPredictions = ({
    items,
  }: {
    items: HerePlaceSuggested[],
  }): {predictions: SuggestedAddress[]} => {
    const predictions: SuggestedAddress[] = items.map(
      (city: HerePlaceSuggested) => ({
        description: city.title,
        placeId: city.id,
      })
    );

    return {predictions};
  };
  formatLocation = (location: {[key: string]: string}): Location => {
    return {
      address1: location.address1,
      address2: location.address2 || undefined,
      lat: location.lat || '',
      lng: location.lng || '',
      admin1: location.admin1,
      admin2: location.admin2,
      admin3: location.admin3 || undefined,
      admin4: location.admin4 || undefined,
      admin5: location.admin5 || undefined,
      admin6: location.admin6 || undefined,
      zipCode: location.zipCode || undefined,
      country: location.country || undefined,
      placeId: location.placeId || undefined,
    };
  };
}
